import { render, staticRenderFns } from "./SfOverlay.vue?vue&type=template&id=71c512ce&"
import script from "./SfOverlay.vue?vue&type=script&lang=js&"
export * from "./SfOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SfOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports